/**
 * @file: ListModel.js
 * @author: liuye11(liuye11@baidu.com)
 */

import ListModel from '../../common/ComponentListModel';
import uri from '@baidu/ve-ria/utils/uri';
import {assign} from 'lodash';

export default class Model extends ListModel {
    getDetailUrl(params) {
        return uri.withQuery(
            '/stats/material/report/link',
            assign(params, this.pickParamsWithDate('aderId'))
        );
    }
}
